module.exports = __webpack_public_path__ + "static/media/in-transit.470983ae.svg";